import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/MemberAccountManagement";

class MemberAccountService {
    create(requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`, 
            requestBody
        , {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(filters, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                ...filters,
                "sortOrder": "id",
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(accountId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${accountId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getStatistics() {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/Statistics`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(accountId, requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${accountId}`,
            requestBody
        , {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    updateProfilePhoto(formData) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/UploadProfilePhoto`,
            formData, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(accountId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${accountId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    exportToExcel(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/ExportExcel`, 
            {
                ...data,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": true,
                    "targetPage": 1,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewMemberAccountService = new MemberAccountService();
export default NewMemberAccountService;